/**
 * Global cart state management hook
 * Provides centralized cart state and loading status for cart-related components
 */

import { useState } from 'preact/hooks'
import { globalState } from '../helpers/utils'
import { Cart } from '../helpers/cart.types'

export const CartConfigKeys = {
  cart: 'cart',
  isLoading: 'isLoading',
  isFetching: 'isFetching'
}

type CartConfigKey = keyof typeof CartConfigKeys

function useCartGlobal() {
  const [cart, setCart] = useState<Cart>(globalState.cart.initCart as Cart)
  const [isFetching, setIsFetching] = useState(false)
  const [isLoaded, setIsLoaded] = useState(true)

  const [cartConfig, setCartConfig] = useState({
    [CartConfigKeys.cart]: globalState.cart.initCart,
    [CartConfigKeys.isLoading]: false,
    [CartConfigKeys.isFetching]: false
  })

  const handleSetCartConfig = (key: CartConfigKey, value: Cart | boolean) => {
    setCartConfig((config) => ({ ...config, [key]: value }))
  }

  return {
    cart,
    setCart,
    isFetching,
    setIsFetching,
    isLoaded,
    setIsLoaded,
    cartConfig,
    handleSetCartConfig
  }
}

export default useCartGlobal
